import { DateComparisonPeriod, useReportBlockCtx } from '@va/ui/components/report-block';
import { useMemo } from 'react';
import { usePreviousPeriodFilter } from './usePreviousPeriodFilter';
import { usePreviousYearPeriodFilter } from './usePreviousYearPeriodFilter';

export const useReportPreviousPeriod = <T extends boolean = true>(keepOffset = true, convertToIso: T = true as T) => {
  const { activeComparisonOption } = useReportBlockCtx();

  const previousTimePeriodHook = useMemo(() => {
    if (activeComparisonOption === DateComparisonPeriod.YOY) {
      return usePreviousYearPeriodFilter;
    }
    return usePreviousPeriodFilter;
  }, [activeComparisonOption]);

  return previousTimePeriodHook(keepOffset, convertToIso);
};
